import styled from 'styled-components';
import { ifProp } from 'styled-tools';

export const OpenTradingPositionsWrapper = styled.div`
  position: relative;
  padding-top: 40px;
  width: 100%;

  @media (max-width: 1100px) {
    margin-top: 30px;
  }
`;

export const OpenTradingPositionsInner = styled.div`
  background: transparent;
  max-width: 750px;
  height: 480px;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const OpenTradingPositionsItem = styled.section`
  position: relative;
  padding: 16px 27px;
  margin-top: 40px;
  width: 240px;
  height: 200px;
  background: #fff;
  box-shadow: 0px 18px 13px 0px rgba(25, 25, 46, 0.04);
`;

export const CanvasArc = styled.canvas`
  position: absolute;
  left: 50%;
  top: 49px;
  transform: translateX(-50%);
`;

export const Title = styled.div`
  font-weight: bold;
  font-size: 18px;
  line-height: 140%;
  text-align: center;
  letter-spacing: 0.02em;
  text-decoration-line: underline;
  color: #2d9cdb;
`;

export const Text = styled.div`
  font-weight: bold;
  font-size: 14px;
  line-height: 140%;
  text-align: center;
  letter-spacing: 0.02em;
  color: ${ifProp('red', 'rgba(246, 84, 62, 1)', ' #1bb15a')};
`;

export const SubText = styled.div`
  font-weight: normal;
  font-size: 10px;
  line-height: 140%;
  text-align: center;
  letter-spacing: 0.02em;
  color: #3f4047;
  margin-top: 13px;
`;

export const ProgressTitle = styled.div`
  font-weight: bold;
  font-size: 18px;
  line-height: 140%;
  text-align: center;
  letter-spacing: 0.02em;
  color: #2d9cdb;
  border-bottom: 2px solid #2d9cdb;
  width: fit-content;
  margin: 0 auto;
`;

export const LongsShorts = styled.div`
  font-weight: bold;
  font-size: 14px;
  line-height: 140%;
  text-align: center;
  letter-spacing: 0.02em;
  color: ${ifProp('red', 'rgba(246, 84, 62, 1)', ' #1bb15a')};
`;

export const InnerFlex = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
  ${LongsShorts} + ${LongsShorts} {
    margin-left: 25px;
  }
`;

export const Flex = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  ${SubText} + ${SubText} {
    margin-left: 18px;
  }

  ${Text} + ${Text} {
    margin-left: 47px;
  }
`;
